import { motion, AnimatePresence } from 'framer-motion';

interface TooltipProps {
  message: string;
  visible: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ message, visible }: TooltipProps) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="absolute bottom-14 left-2 mt-2 rounded-lg bg-primary-500 px-2 py-1 font-bold text-black"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}>
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Tooltip;
